import { render, staticRenderFns } from "./TableViewTwo.vue?vue&type=template&id=18a08819&"
import script from "./TableViewTwo.vue?vue&type=script&lang=js&"
export * from "./TableViewTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports